import React from "react"
import styles from "./CommonTitle.module.scss"

// タイトル部文言の最後に句読点がある場合、中央寄せに見えないためチェックを追加
const isCommaOrPeriodAtEnd = (str: string) => {
  return str.slice(-1) === "、" || str.slice(-1) === "。"
}

export interface CommonTitleProps {
  titles: string[]
  read: string | React.ReactNode
  detail?: string
  preTitle?: string
}
/**
 * 画面共通のタイトル部品
 * @param {string[]} titles - タイトル文言
 * @param {string | React.ReactNode} read - タイトル直下に入れる文言
 * @param {string} detail - 詳細文言（未使用のため、削除予定）
 * @param {string} preTitle -（未使用のため、削除予定）
 */
const CommonTitle = ({ titles, read, detail, preTitle }: CommonTitleProps) => {
  return (
    <>
      <>
        <h2 className={styles.title}>
          {titles.map((title) => {
            return isCommaOrPeriodAtEnd(title) ? (
              <span style={{ paddingLeft: "12px" }} key={title}>
                {title}
              </span>
            ) : (
              <span key={title}>{title}</span>
            )
          })}
        </h2>
        <p className={styles.titleRead}>{read}</p>
        {detail && <p className={styles.titleRead}>{detail}</p>}
      </>
    </>
  )
}

export default CommonTitle
